import { render, staticRenderFns } from "./receipt-customer-info.vue?vue&type=template&id=38439e7d"
import script from "./receipt-customer-info.vue?vue&type=script&lang=js"
export * from "./receipt-customer-info.vue?vue&type=script&lang=js"
import style0 from "./receipt-customer-info.vue?vue&type=style&index=0&id=38439e7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports